import { managedPageQueryMeta, throwIfResponseNotOk } from '@/queries/queryErrorHandling';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import { QueryFunction, useQuery } from '@tanstack/react-query';

import { EenheidStatus } from '../types/ddpTypes';

const useGetEenhedenStatus = () => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetcher: QueryFunction<EenheidStatus[]> = async () => {
    const response = await fetchWithAuth(`/eenheid/v1/geefAlleEenhedenStatus`);
    throwIfResponseNotOk(response, `Ophalen van eenhedenstatus is mislukt (${response.status}).`);
    return await response.json();
  };

  return useQuery({
    queryKey: ['geefAlleEenhedenStatus'],
    queryFn: fetcher,
    refetchInterval: 60_000,
    meta: managedPageQueryMeta,
  });
};
export default useGetEenhedenStatus;
